var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyWatchlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 484.631,
    height: 181.907,
    viewBox: "0 0 484.631 181.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_445",
    x: 213.754,
    y: 19.147,
    width: 246.877,
    height: 113.104,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.122
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4548",
    x: 213.754,
    y: 16.147,
    width: 246.877,
    height: 81.104,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11525",
    "data-name": "Group 11525",
    transform: "translate(-426.018 -260.721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929",
    transform: "translate(675.771 311.868)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -249.75, -51.15)",
    filter: "url(#Rectangle_445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_445-2",
    "data-name": "Rectangle 445",
    transform: "translate(249.75 51.15)",
    fill: "#fff",
    stroke: "rgba(177,177,177,0.2)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.877,
    height: 41.104,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 173.877,
    height: 40.104,
    rx: 4.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1081",
    "data-name": "Rectangle 1081",
    width: 27.078,
    height: 4.513,
    transform: "translate(9.026 27.077)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1082",
    "data-name": "Rectangle 1082",
    width: 36.104,
    height: 9.026,
    transform: "translate(129.747 13.539)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1083",
    "data-name": "Rectangle 1083",
    width: 27.078,
    height: 4.513,
    transform: "translate(138.773 27.077)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1084",
    "data-name": "Rectangle 1084",
    width: 63.181,
    height: 9.026,
    transform: "translate(9.026 13.539)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -249.75, -51.15)",
    filter: "url(#Rectangle_4548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4548-2",
    "data-name": "Rectangle 4548",
    d: "M3,0H171.877a3,3,0,0,1,3,3V9.1a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3A3,3,0,0,1,3,0Z",
    transform: "translate(249.75 48.15)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 1.237,
    cy: 1.237,
    r: 1.237,
    transform: "translate(10.781 0.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 1.237,
    cy: 1.237,
    r: 1.237,
    transform: "translate(15.477 0.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    cx: 1.237,
    cy: 1.237,
    r: 1.237,
    transform: "translate(6.073 0.526)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931",
    transform: "translate(486.019 325.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_445-3",
    "data-name": "Rectangle 445",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "rgba(177,177,177,0.2)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.877,
    height: 36.104,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 173.877,
    height: 35.104,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1081-2",
    "data-name": "Rectangle 1081",
    width: 27.078,
    height: 4.513,
    transform: "translate(9.026 22.565)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1082-2",
    "data-name": "Rectangle 1082",
    width: 36.104,
    height: 9.026,
    transform: "translate(129.747 9.026)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1083-2",
    "data-name": "Rectangle 1083",
    width: 27.078,
    height: 4.513,
    transform: "translate(138.773 22.565)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1084-2",
    "data-name": "Rectangle 1084",
    width: 63.181,
    height: 9.026,
    transform: "translate(9.026 9.026)",
    fill: "#ccc",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11678",
    "data-name": "Group 11678",
    transform: "translate(735.771 388.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_445-4",
    "data-name": "Rectangle 445",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "rgba(177,177,177,0.2)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.877,
    height: 36.104,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 173.877,
    height: 35.104,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1081-3",
    "data-name": "Rectangle 1081",
    width: 27.078,
    height: 4.513,
    transform: "translate(9.026 22.565)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1082-3",
    "data-name": "Rectangle 1082",
    width: 36.104,
    height: 9.026,
    transform: "translate(129.747 9.026)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1083-3",
    "data-name": "Rectangle 1083",
    width: 27.078,
    height: 4.513,
    transform: "translate(138.773 22.565)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1084-3",
    "data-name": "Rectangle 1084",
    width: 63.181,
    height: 9.026,
    transform: "translate(9.026 9.026)",
    fill: "#ccc",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932",
    transform: "translate(426.018 261.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_445-5",
    "data-name": "Rectangle 445",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "rgba(177,177,177,0.2)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.877,
    height: 36.104,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 173.877,
    height: 35.104,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1081-4",
    "data-name": "Rectangle 1081",
    width: 27.078,
    height: 4.513,
    transform: "translate(9.026 22.565)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1082-4",
    "data-name": "Rectangle 1082",
    width: 36.104,
    height: 9.026,
    transform: "translate(129.747 9.026)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1083-4",
    "data-name": "Rectangle 1083",
    width: 27.078,
    height: 4.513,
    transform: "translate(138.773 22.565)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1084-4",
    "data-name": "Rectangle 1084",
    width: 63.181,
    height: 9.026,
    transform: "translate(9.026 9.026)",
    fill: "#ccc",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11677",
    "data-name": "Group 11677",
    transform: "translate(426.018 389.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_445-6",
    "data-name": "Rectangle 445",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "rgba(177,177,177,0.2)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.877,
    height: 36.104,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 173.877,
    height: 35.104,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1081-5",
    "data-name": "Rectangle 1081",
    width: 27.078,
    height: 4.513,
    transform: "translate(9.026 22.565)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1082-5",
    "data-name": "Rectangle 1082",
    width: 36.104,
    height: 9.026,
    transform: "translate(129.747 9.026)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1083-5",
    "data-name": "Rectangle 1083",
    width: 27.078,
    height: 4.513,
    transform: "translate(138.773 22.565)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1084-5",
    "data-name": "Rectangle 1084",
    width: 63.181,
    height: 9.026,
    transform: "translate(9.026 9.026)",
    fill: "#ccc",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11679",
    "data-name": "Group 11679",
    transform: "translate(735.771 260.721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_445-7",
    "data-name": "Rectangle 445",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "rgba(177,177,177,0.2)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.877,
    height: 36.104,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 173.877,
    height: 35.104,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1081-6",
    "data-name": "Rectangle 1081",
    width: 27.078,
    height: 4.513,
    transform: "translate(9.026 22.565)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1082-6",
    "data-name": "Rectangle 1082",
    width: 36.104,
    height: 9.026,
    transform: "translate(129.747 9.026)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1083-6",
    "data-name": "Rectangle 1083",
    width: 27.078,
    height: 4.513,
    transform: "translate(138.773 22.565)",
    fill: "#ccc",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1084-6",
    "data-name": "Rectangle 1084",
    width: 63.181,
    height: 9.026,
    transform: "translate(9.026 9.026)",
    fill: "#ccc",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("g", {
    id: "add-scrip",
    transform: "translate(755.442 299.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_24",
    "data-name": 24,
    d: "M0,0H24.818V24.818H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Icon",
    "data-name": "+ Icon",
    transform: "translate(1.935 1.935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_680",
    "data-name": "Ellipse 680",
    cx: 10.474,
    cy: 10.474,
    r: 10.474,
    transform: "translate(0 0)",
    fill: "#ffb13b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_259",
    "data-name": "Ellipse 259",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#ffb13b",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.474,
    cy: 10.474,
    r: 10.474,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.474,
    cy: 10.474,
    r: 9.724,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M16.531,11.589H11.589v4.942H9.942V11.589H5V9.942H9.942V5h1.647V9.942h4.942Z",
    transform: "translate(-0.292 -0.292)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11524",
    "data-name": "Group 11524",
    transform: "translate(630.507 287.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11681",
    "data-name": "Group 11681",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9180",
    "data-name": "Path 9180",
    d: "M488.7,89.215l-7.2,3.991,7.683-2.71Z",
    transform: "translate(-333.49 -131.74) rotate(8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_675",
    "data-name": "Ellipse 675",
    cx: 2.01,
    cy: 4.05,
    rx: 2.01,
    ry: 4.05,
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 137.316, 21.335)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9181",
    "data-name": "Path 9181",
    d: "M509.46,79.4l4.779-1.725,1.016,2.813-4.625,3.124Z",
    transform: "translate(-352.668 -126.808) rotate(8)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9182",
    "data-name": "Path 9182",
    d: "M677.172,244.1a3.731,3.731,0,0,0,5.23,2.318l9.422,9.326,1.351-6.755-9.154-7.821a3.751,3.751,0,0,0-6.848,2.932Z",
    transform: "translate(-533.202 -220.103)",
    fill: "#ca8e97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9183",
    "data-name": "Path 9183",
    d: "M919.63,420.514a3.731,3.731,0,0,0-.876-5.653l2.755-12.968-6.414,2.515-1.633,11.929a3.751,3.751,0,0,0,6.168,4.177Z",
    transform: "translate(-703.861 -337.671)",
    fill: "#ca8e97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9184",
    "data-name": "Path 9184",
    d: "M649.507,497.354h-4.548l-2.164-17.543h6.713Z",
    transform: "translate(-464.776 -346.929)",
    fill: "#ca8e97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9185",
    "data-name": "Path 9185",
    d: "M790.656,713.687H775.991V713.5a5.708,5.708,0,0,1,5.708-5.708h8.957Z",
    transform: "translate(-604.765 -558.854)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9186",
    "data-name": "Path 9186",
    d: "M729.88,497.354h-4.548l-2.164-17.543h6.713Z",
    transform: "translate(-522.89 -346.929)",
    fill: "#ca8e97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9187",
    "data-name": "Path 9187",
    d: "M871.029,713.688H856.364V713.5a5.708,5.708,0,0,1,5.708-5.708h8.957Z",
    transform: "translate(-662.879 -558.854)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9188",
    "data-name": "Path 9188",
    d: "M805.474,512.044l-6.438-.258a1.675,1.675,0,0,1-1.6-1.719l1.814-59.5.118-.043c11.284-4.082,20.619-3.773,28.538.942l.089.053,1.087,57.948a1.669,1.669,0,0,1-1.669,1.7h-5.429a1.673,1.673,0,0,1-1.638-1.347l-7.4-37.621a.556.556,0,0,0-1.1.041L807.2,510.577a1.679,1.679,0,0,1-1.658,1.468Z",
    transform: "translate(-620.269 -370.779)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_676",
    "data-name": "Ellipse 676",
    cx: 9.112,
    cy: 9.112,
    r: 9.112,
    transform: "translate(179.102 14.877) rotate(-28.663)",
    fill: "#ca8e97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9190",
    "data-name": "Path 9190",
    d: "M889.952,333.495a1.671,1.671,0,0,1-1,.043l-3.062-.814a1.675,1.675,0,0,1-1.234-1.469l-1.037-11.921-10.759-18.953a5.378,5.378,0,1,1,10.1-3.693l7.394,11.581a17.2,17.2,0,0,1,2.509,11.848l-1.833,12.059a1.669,1.669,0,0,1-1.084,1.319Z",
    transform: "translate(-674.572 -259.048)",
    fill: "#646181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9191",
    "data-name": "Path 9191",
    d: "M802.318,282.017a15.515,15.515,0,0,1,12.442-5.03q.229.014.455.032h0a15.482,15.482,0,0,1,11.189,6.176,15.716,15.716,0,0,1,2.792,12.667,49.1,49.1,0,0,0,1.3,25.181l2.444,7.59a1.669,1.669,0,0,1-1.5,2.178l-12.5.672-3.2-5.524v5.7l-15.188.817-.09,0a1.669,1.669,0,0,1-1.663-1.8l1.717-21.288-2.153-14.458A15.614,15.614,0,0,1,802.318,282.017Z",
    transform: "translate(-620.816 -247.335)",
    fill: "#646181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9192",
    "data-name": "Path 9192",
    d: "M823.956,216.007c-.844.485-4.178.807-4.416-.137l-.005-.021a7.108,7.108,0,0,1,.019-2.123,2.66,2.66,0,0,0-.505-2.01c-.9-.972-2.5-.457-3.806-.7a3.214,3.214,0,0,1-2.5-3.433c.019-.147.048-.3.08-.443a2.476,2.476,0,0,0-2.57-3c-1.316.075-2.737.474-3.826-.5a4.179,4.179,0,0,1-.678-3.785c.622-1.795,4.605-2.735,6.344-3.251a15.069,15.069,0,0,1,12.773,2.1,6.763,6.763,0,0,1,2.593,3.007,3.293,3.293,0,0,1-.813,3.681,6.8,6.8,0,0,1,1.575,6.606C827.7,213.673,825.212,215.284,823.956,216.007Z",
    transform: "translate(-626.155 -188.807)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9194",
    "data-name": "Path 9194",
    d: "M702.487,262.926a1.671,1.671,0,0,1,.677-.731l2.748-1.578a1.675,1.675,0,0,1,1.91.174l9.13,7.735,20.985,5.883a5.378,5.378,0,0,1-4.574,9.735l-13.4-3.018a17.2,17.2,0,0,1-10.124-6.647l-7.189-9.853a1.671,1.671,0,0,1-.284-1.331A1.653,1.653,0,0,1,702.487,262.926Z",
    transform: "translate(-551.5 -235.362)",
    fill: "#646181"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWatchlist);
export default __webpack_public_path__ + "static/media/empty-watchlist.17d7749e590a37ef43eddcce1cb148bb.svg";
export { ForwardRef as ReactComponent };